import { Create } from "react-admin";
import { CommunicationTabbedForm } from "./CommunicationTabbedForm";

export const CommunicationCreate = (props) => (
  <Create title="Criação de Comunicação" {...props}>
    <CommunicationTabbedForm {...props} />
  </Create>
);
